import React, { useEffect, useRef, useState } from 'react'; 
import '../styles/components/Choose.css';
import iconImage from '../assets/jve.jpg';

// ✅ Importing clean professional icons
import { CheckCircle, Zap, Clock } from "lucide-react";

const Choose = () => {
  const containerRef = useRef(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const current = containerRef.current;
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) setVisible(true);
      },
      { threshold: 0.3 }
    );

    if (current) observer.observe(current);

    return () => {
      if (current) observer.unobserve(current);
    };
  }, []);

  const cards = [
    {
      icon: <CheckCircle size={40} color="#225378" strokeWidth={1.8} />, // sleek black
      title: 'Accountable',
      desc: 'We take ownership of every step, ensuring transparency and clarity in all construction and renovation projects. '
    },
    {
      icon: <Zap size={40} color="#225378" strokeWidth={1.8} />, 
      title: 'Responsible',
      desc: 'Your safety and satisfaction are our priority. We work with care and dedication to deliver projects that last. Over 30+ Years of Expertise in Structural Solutions. '
    },
    {
      icon: <Clock size={40} color="#225378" strokeWidth={1.8} />,
      title: 'Discipline',
      desc: 'Timely delivery, organized execution, and quality focus guide every project, making your vision a reality. Trusted by 300+ Happy Clients for exceptional results.'
    }
  ];

  return (
    <section id="Choose" className="why-choose-us" ref={containerRef}>
      <div className={`container ${visible ? 'visible' : ''}`}>
        <div className="content">
          <h2 className="choose-heading">
            What makes <img src={iconImage} alt="icon" className="inline-icon" /> Stand Out?
          </h2>

          <p className="description">
            Jai Vishwakarma Enterprises upholds every commitment with accountability, responsibility, and discipline, creating the foundation for lasting trust.
          </p>

          <div className="features">
            {cards.map((card, index) => (
              <div
                className={`feature ${visible ? 'visible' : ''}`}
                key={index}
                style={{ transitionDelay: `${index * 0.3}s` }}
              >
                <div className="icon">{card.icon}</div>
                <div className="text">
                  <h4>{card.title}</h4>
                  <p>{card.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Choose;
